import React from 'react';
import {Contact} from "@gik/contact";

export default function ContactContainer() {
  return <Contact />;
}
